module.exports = __webpack_public_path__ + "static/img/2bd29461d2648135a08049fbb0dbf22.c983473.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2bd29461d2648135a08049fbb0dbf22.jpg
// module id = tg4j
// module chunks = 4